import { pick } from 'lodash';
import { API_GATEWAY_URL } from '../constants/config';
import { EventCreateRequestBodyFieldKeys, EventUpdateRequestBodyFieldKeys, } from '../interfaces/event';
import { withStandardHandlers } from './utils';
const PROJECTS_API_URL = `${API_GATEWAY_URL}/projects`;
export const GET_RPOJECTS_API_URL = (...args) => `${PROJECTS_API_URL}/${args.join('/')}`;
/**
 * Get all events.
 * Events are an alias for projects on platform app.
 *
 * @param accessToken - The access token for authentication.
 */
export const getEvents = async (accessToken) => {
    const doFetch = async (allEvents, lastEvaluatedKey) => {
        const params = new URLSearchParams({ limit: '1000' });
        if (lastEvaluatedKey) {
            params.append('last_evaluated_key', JSON.stringify(lastEvaluatedKey));
        }
        const fn = () => {
            return fetch(`${PROJECTS_API_URL}?${params.toString()}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    responseType: 'json',
                    'X-Authorization': `Bearer ${accessToken}`,
                },
            });
        };
        const response = await withStandardHandlers(fn, 'errors.event.fetch', false)();
        allEvents.push(...response.projects);
        if (response.last_evaluated_key) {
            return doFetch(allEvents, response.last_evaluated_key);
        }
        return allEvents;
    };
    return doFetch([]);
};
/**
 * Get an event by ID
 * @param accessToken - The access token for authentication.
 * @param eventId - The event ID.
 */
export const getEvent = (accessToken, eventId) => {
    const fn = () => fetch(`${PROJECTS_API_URL}/${eventId}&isEvents`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            responseType: 'json',
            'X-Authorization': `Bearer ${accessToken}`,
        },
    });
    return withStandardHandlers(fn, 'errors.event.fetch')();
};
/**
 * Create a new event
 * @param accessToken - The access token for authentication.
 * @param event - The event details to create.
 */
export const postEvent = (accessToken, event) => {
    const fn = () => fetch(`${PROJECTS_API_URL}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            responseType: 'json',
            'X-Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(pick(event, EventCreateRequestBodyFieldKeys)),
    });
    return withStandardHandlers(fn, 'errors.event.create')().then((res) => res.project);
};
/**
 * Update an existing event
 * @param accessToken - The access token for authentication.
 * @param eventId - The ID of the event to update.
 * @param event - The event details to update.
 */
export const patchEvent = (accessToken, eventId, event) => {
    const fn = () => fetch(`${PROJECTS_API_URL}/${eventId}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            responseType: 'json',
            'X-Authorization': `Bearer ${accessToken}`,
        },
        body: JSON.stringify(pick(event, EventUpdateRequestBodyFieldKeys)),
    });
    return withStandardHandlers(fn, 'errors.event.update')();
};
/**
 * Delete an event
 * @param accessToken - The access token for authentication.
 * @param eventId - The event ID to delete.
 */
export const deleteEvent = (accessToken, eventId) => {
    const fn = () => fetch(`${PROJECTS_API_URL}/${eventId}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            responseType: 'json',
            'X-Authorization': `Bearer ${accessToken}`,
        },
    });
    return withStandardHandlers(fn, 'errors.event.delete')();
};
